<template>	
	<div class="map-file" style="margin-top: 5px;">
	  <!-- 数据分析管理 -->
	  <el-row :gutter="24">		  
		<el-col :span="6" class="shadow">		
		  <!-- 车辆列表部分 -->
		  <div>
			  <!-- 查找参数区 -->
			  
			  <div class="filter-container">
				  <el-input placeholder="请输入机器人ID" v-model="listQueryCar.params.id"  class="filter-item" style="width: 60%;" ></el-input>
				  <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleFilterCar(true)">
					搜索
				  </el-button>
			  </div>
			 
			  <!-- 数据列表区 -->
			  <el-table
				:data="listDataCar"
				v-loading="listLoadingCar"
				border
				highlight-current-row
				style="width: 100%;align: center;">
				<el-table-column prop="index" label="序号" width="60px" align="center">
				</el-table-column>
				<el-table-column prop="name" label="机器人名称" align="center">
				</el-table-column>
				<el-table-column prop="operator" label="操作" align="center">
				  <template v-slot:="{row,$index}">
					<el-button type="primary" size="mini"  @click="handleCarUse(row)"><!--@click="handleShowReportList(row)" -->
					  查看
					</el-button> 
				  </template>
				</el-table-column>
			  </el-table>
	      
			  <!-- 分页栏 -->
			  <pagination :total="totalCountsCar" :page="listQueryCar.pageIndex" layout='sizes,prev, pager, next'
				@pagination="handlePageChangeCar" small :pager-count="5">
			  </pagination>
			</div>
		</el-col>
		
		<!-- 文件列表部分 -->
	    <el-col :span="18" class="shadow">
			<div class="car-id">
			    地图文件所属机器人ID:
			    <el-input
			      style="width: 310px"
			      placeholder=""
			      v-model="curCarId"
			      :disabled="true">
			    </el-input>
				<el-input style="display: none;"  v-model="curCarName"> </el-input>
			</div>
			<el-form label-width="160px" ref="carUseForm" :model="carUseForm" style="margin-top: 10px;">
				<el-row>
					<el-col :span="10">
						<el-form-item label="主刷剩余寿命(小时)" prop="masterBrushAvailable">
							<el-input placeholder="" v-model="carUseForm.masterBrushAvailable">
							</el-input>
						</el-form-item>
					</el-col>		
					<el-col :span="10">
						<el-form-item label="主刷更换次数(次)" prop="replaceMasterBrush">
							<el-input placeholder="" v-model="carUseForm.replaceMasterBrush">
							</el-input>
						</el-form-item>
					</el-col>			
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="边刷剩余寿命(小时)" prop="edgeBrushAvailable">
							<el-input placeholder="" v-model="carUseForm.edgeBrushAvailable">
							</el-input>
						</el-form-item>
					</el-col>		
					<el-col :span="10">
						<el-form-item label="边刷更换次数(次)" prop="replaceEdgeBrush">
							<el-input placeholder="" v-model="carUseForm.replaceEdgeBrush">
							</el-input>
						</el-form-item>
					</el-col>			
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="滤芯剩余寿命(小时)" prop="filterAvailable">
							<el-input placeholder="" v-model="carUseForm.filterAvailable">
							</el-input>
						</el-form-item>
					</el-col>		
					<el-col :span="10">
						<el-form-item label="滤芯更换次数(次)" prop="replaceFilter">
							<el-input placeholder="" v-model="carUseForm.replaceFilter">
							</el-input>
						</el-form-item>
					</el-col>			
				</el-row>	
				<el-row>
					<el-col :span="10">
						<el-form-item label="前档皮剩余寿命(小时)" prop="frontStallCoverAvailable">
							<el-input placeholder="" v-model="carUseForm.frontStallCoverAvailable">
							</el-input>
						</el-form-item>
					</el-col>		
					<el-col :span="10">
						<el-form-item label="前档皮更换次数(次)" prop="replaceFrontStallCover">
							<el-input placeholder="" v-model="carUseForm.replaceFrontStallCover">
							</el-input>
						</el-form-item>
					</el-col>			
				</el-row>	
				<el-row>
					<el-col :span="10">
						<el-form-item label="侧档皮剩余寿命(小时)" prop="sideStallCoverAvailable">
							<el-input placeholder="" v-model="carUseForm.sideStallCoverAvailable">
							</el-input>
						</el-form-item>
					</el-col>		
					<el-col :span="10">
						<el-form-item label="侧档皮更换次数(次)" prop="replaceSideStallCover">
							<el-input placeholder="" v-model="carUseForm.replaceSideStallCover">
							</el-input>
						</el-form-item>
					</el-col>			
				</el-row>	
				<el-row>
					<el-col :span="12" style="text-align: center;">
						<el-button type="primary" @click="updateInfo()">更新</el-button>
					</el-col>
				</el-row>
			</el-form>
	    </el-col>
			
	  </el-row>
  </div>	
</template>

<script>
	import Pagination from '@/components/common/Pagination'
	import {carList,setCarPartsUsing} from '@/api/car'
	
	export default{
		data(){
			return{				
				curEntityId:this.$store.getters['user/entityId'],
				treeListLoading:true,
				entityTree:[],
				
				loginuser:this.$store.getters['user/userName'],
				// 车辆列表部分
				listLoadingCar: false,
				listDataCar: [],
				totalCountsCar: 0,
				listQueryCar: {
				  entityId: this.$store.getters['user/entityId'],
				  pageIndex: 1,
				  pageSize: 10,
				  params: {
				    id: undefined
				  },
				  fuzzySearch: true
				},
				curCarId:undefined,
				curCarName:'',
				carUseForm:{}
			}
		},
		mounted(){
		    this.handleFilterCar()
		},
		components: {
		  Pagination
		},
		methods:{
			/**
			 * 请求车辆数据
			 */
			handleFilterCar(isNewSearch = false) {
			  //如果是“新搜索”（即非翻页，而是点击搜索按钮进行搜索）
			  if(isNewSearch) {
			    //页数修改1
			    this.listQueryCar.pageIndex = 1;
			  }
			
			  this.listLoadingCar = true
			  carList(this.listQueryCar, null).then(res => {
			    let data = res.pageData
			    this.totalCountsCar = data.totalCounts
				if(data.datas!=null && data.datas.length > 0){
					// 对后端数据进行解析
					this.listDataCar = data.datas.map((item,index) => {
					  // return {
					  //   index: index+1,
					  //   id: item.id,
					  //   name: item.name
					  // }
					  item.index = index+1
					  return item
					})
				}
			    this.listLoadingCar = false
			  })
			},
			/**
			 * 处理小车列表翻页
			 */
			handlePageChangeCar(data) {
			  this.listQueryCar.pageIndex = data.page
			  this.listQueryCar.pageSize = data.limit
			  this.handleFilterCar()
			},
			handleCarUse(row){
				this.curCarId = row.id
				this.curCarName = row.name
				this.carUseForm = row
			},
			updateInfo(){
				setCarPartsUsing(this.carUseForm).then(res =>{
					if (res.result == '0') {
					  this.$alert('更新成功');				  
					} else {
					  this.$alert(res.message);
					}
				})
			}
		////	
		}
	}
	
</script>
<style>
</style>

